import type { PropsWithChildren } from 'react'
import { useCallback, useMemo, useState } from 'react'

import type { InlineItemCreateContextValue } from './InlineItemCreateContext'
import InlineItemCreateContext from './InlineItemCreateContext'

export default function InlineItemCreateProvider({ children }: PropsWithChildren<{ }>) {
  const [selectedDate, setSelectedDate] = useState<string | undefined>(undefined)

  const clearDate = useCallback(() => setSelectedDate(undefined), [])

  const value = useMemo<InlineItemCreateContextValue>(() => ({
    selectedDate,
    setDate: setSelectedDate,
    clearDate,
  }), [clearDate, selectedDate])

  return (
    <InlineItemCreateContext.Provider value={value}>
      {children}
    </InlineItemCreateContext.Provider>
  )
}
